import {
  CommunityActivityAttachmentType,
  CommunityActivityRingCentralCommunicationType,
  CommunityActivityRingCentralMediaType,
} from 'types/communities';

const getFileExtension = (fileName: string) => fileName.split('.').pop()?.toLowerCase() || 'file';

export const getRingCentralActivityAttachments = (
  communication?: CommunityActivityRingCentralCommunicationType | null
): CommunityActivityAttachmentType[] => {
  if (!communication) {
    return [];
  }

  return communication.media
    .filter((media) => Boolean(media.file_url && media.file_name))
    .map((media: CommunityActivityRingCentralMediaType) => ({
      file_extension: getFileExtension(media.file_name as string),
      file_name: media.file_name as string,
      file_url: media.file_url as string,
      id: `ringcentral-media-${media.id}`,
    }));
};
